const posts = [
    {
        id: 1,
        title: "The Joy of Flowers",
        author: "Anna Bell",
        date: "October 10, 2024",
        content: "Flowers have a unique way of brightening up our days. In this post, we explore how flowers can not only enhance the beauty of our surroundings but also improve our mood and mental health."
    },
    {
        id: 2,
        title: "Sustainable Practices in Floristry",
        author: "Beth Clarke",
        date: "October 15, 2024",
        content: "At SisterFlora, sustainability is at the heart of everything we do. Learn about the steps we're taking to ensure our practices help preserve the environment."
    },
    {
        id: 3,
        title: "Flower Arrangements 101",
        author: "Cara Smith",
        date: "October 20, 2024",
        content: "Interested in learning how to create beautiful flower arrangements? This beginner's guide will provide you with all the tips and tricks you need to get started."
    },
    {
        id: 4,
        title: "The Art of Bonsai",
        author: "Michael Lee",
        date: "November 1, 2024",
        content: "Explore the ancient art of bonsai and learn how these miniature trees can bring a sense of peace and persistence to your home."
    },
    {
        id: 5,
        title: "Winter Flower Care",
        author: "Jessica Green",
        date: "November 5, 2024",
        content: "Caring for your flowers during the colder months is crucial. Discover essential tips to protect your blooms from the winter chill."
    },
    {
        id: 6,
        title: "Wedding Flowers on a Budget",
        author: "Emily White",
        date: "November 10, 2024",
        content: "Planning a wedding? Learn how to choose beautiful flowers that won’t break the bank, ensuring your big day looks lush for less."
    },
    {
        id: 7,
        title: "The Psychology of Colors in Flowers",
        author: "Richard Fox",
        date: "November 15, 2024",
        content: "Flowers are more than just a visual delight; their colors can significantly affect mood and emotions. Find out how to use this to your advantage."
    },
    {
        id: 8,
        title: "Eco-Friendly Gardening Tips",
        author: "Samantha Bee",
        date: "November 20, 2024",
        content: "Make your garden a beacon of sustainability with these eco-friendly gardening tips that help the planet and your plants thrive."
    },
    {
        id: 9,
        title: "The Best Perennials for Full Sun",
        author: "Greg Holland",
        date: "November 25, 2024",
        content: "Looking for plants that thrive in full sun? Discover the best perennials that will add color and life to your sunny garden spots."
    },
    {
        id: 10,
        title: "Herbal Gardens: Growing Your Own Flavors",
        author: "Lisa Ray",
        date: "November 30, 2024",
        content: "Herbal gardens are not only aromatic and practical, but they also enhance your cooking. Learn how to start your own with these simple steps."
    }
];

module.exports = posts;